import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { SPONSA_CSS } from "./sponsaCSS";
import ConfirmModal from "../../../components/Dashcomponents/New/ConfirmModal";
import OnboardingCompleteModal from "../../../components/Dashcomponents/OnboardingCompleteModal.jsx";
import apisecured from "../../../api/apisecured.js";
import { setTwitterConnection } from "../../../State/authSlicer.js";
import { useUnsavedChanges } from "../../../hooks/useUnsavedChanges.js";
import { setToast } from "../../../State/toastSlice.js";

// ─── PREVIEW CSS ──────────────────────────────────────────────────────────────
const PREVIEW_CSS = `
  .confirm-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(3, 0, 33, 0.85);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    display: flex; align-items: center; justify-content: center;
    z-index: 2000; opacity: 0; visibility: hidden;
    transition: all 0.2s ease;
  }
  .confirm-modal-overlay.visible { opacity: 1; visibility: visible; }
  .confirm-modal {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 16px; padding: 24px;
    max-width: 400px; width: 90%;
    transform: scale(0.95); transition: transform 0.2s ease;
  }
  .confirm-modal-overlay.visible .confirm-modal { transform: scale(1); }
  .preview-modal-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 16px; padding-bottom: 16px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
  }
  .preview-modal-platform {
    display: flex; align-items: center; gap: 8px;
    font-size: 14px; font-weight: 600; color: #fff;
  }
  .preview-close-btn {
    width: 32px; height: 32px; border-radius: 8px;
    background: rgba(255,255,255,0.04); border: none;
    color: rgba(255,255,255,0.6); cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.2s ease;
  }
  .preview-close-btn:hover { background: rgba(255,255,255,0.06); color: #fff; }
  .preview-modal-body { margin-bottom: 20px; }
  .preview-image-section { margin-bottom: 16px; }
  .preview-image-label {
    font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.4);
    text-transform: uppercase; letter-spacing: 0.5px;
    margin-bottom: 8px; display: flex; align-items: center; gap: 6px;
  }
  .preview-image-label svg { width: 12px; height: 12px; color: #f472b6; }
  .preview-image-placeholder {
    width: 100%; aspect-ratio: 16/9;
    background: linear-gradient(135deg, rgba(244,114,182,0.1) 0%, rgba(168,85,247,0.1) 100%);
    border: 1px solid rgba(255,255,255,0.08); border-radius: 10px;
    display: flex; flex-direction: column; align-items: center;
    justify-content: center; gap: 8px; color: rgba(255,255,255,0.4);
  }
  .preview-image-placeholder svg { width: 32px; height: 32px; opacity: 0.5; }
  .preview-image-placeholder span { font-size: 12px; }
  .preview-label-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 10px;
  }
  .preview-label {
    font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.6);
    text-transform: uppercase; letter-spacing: 0.5px;
  }
  .preview-sample-badge {
    font-size: 10px; font-weight: 600; color: #fbbf24;
    background: rgba(251,191,36,0.1); padding: 3px 8px; border-radius: 4px;
  }
  .preview-message-box {
    background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px; padding: 16px; font-size: 14px;
    color: #fff; line-height: 1.6; white-space: pre-wrap;
    word-wrap: break-word; max-height: 200px; overflow-y: auto;
  }
  .preview-message-box a { color: #00FF8F; text-decoration: none; border-bottom: 1px solid transparent; transition: all 0.15s ease; }
  .preview-message-box a:hover { border-bottom-color: #00FF8F; }
  .preview-modal-footer { display: flex; gap: 12px; justify-content: center; }
.variable-chip {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  padding: 4px 8px;
  background: rgba(0, 255, 143, 0.1);
  color: #00FF8F;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
}

.variable-chip:hover {
  background: #00FF8F;
  color: #030021;
}

.variable-chip::before,
.variable-chip::after {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 9999;
}

.variable-chip::after {
  content: attr(data-tooltip);
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: linear-gradient(135deg, rgba(3, 0, 33, 0.97), rgba(10, 5, 40, 0.97));
  border: 1px solid #00FF8F;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4), 0 0 12px rgba(0, 255, 143, 0.1);
  color: #ffffff;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 8px;
  white-space: nowrap;
  letter-spacing: 0;
}

.variable-chip::before {
  content: '';
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  border: 5px solid transparent;
  border-top-color: #00FF8F;
}

.variable-chip:hover::before,
.variable-chip:hover::after {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
    .template-var-warning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  background: rgba(251, 191, 36, 0.08);
  border: 1px solid rgba(251, 191, 36, 0.25);
  border-radius: 8px;
  margin-top: 8px;
  font-size: 12px;
  color: #fbbf24;
  line-height: 1.5;
}

.template-var-warning svg {
  flex-shrink: 0;
  margin-top: 1px;
  color: #fbbf24;
  stroke: #fbbf24;
}

.template-var-warning code {
  background: rgba(251, 191, 36, 0.15);
  color: #fbbf24;
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 11px;
  font-family: monospace;
}
`;

const SAMPLE_DATA = {
  tipper: "CoolGamer123",
  amount: "£10",
  goal: "New Gaming Setup",
  goalurl: "https://sponsa.app/VeloCity/goals/gaming-setup",
  progress: "75%",
  remaining: "£125",
  target: "£500",
  username: "VeloCity",
};

function linkifyUrls(text) {
  const escaped = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  const urlPattern = /(https?:\/\/[^\s]+)|(sponsa\.app\/[^\s]+)/g;
  return escaped.replace(urlPattern, (match) => {
    const href = match.startsWith("http") ? match : "https://" + match;
    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
  });
}

const X_DEFAULTS = {
  goalTip:
    '{tipper} just tipped {amount} towards "{goal}"! 🎯 ({progress} funded) Thank you! ❤️ {goalurl} #SPONSA',
  goalComplete:
    '🎉 GOAL COMPLETE! "{goal}" has been fully funded on SPONSA!\n\nThank you to everyone who contributed! ❤️\n\nCheck out my other goals here! sponsa.app/{username} #SPONSA',
  generalTip:
    "❤️ Just received a tip from {tipper} on SPONSA! Thank you so much for the support! sponsa.app/{username} #SPONSA",
};

const X_VARS = {
  goalTip: [
    "tipper",
    "amount",
    "goal",
    "goalurl",
    "progress",
    "remaining",
    "target",
    "username",
  ],
  goalComplete: ["goal", "goalurl", "target", "progress", "username"],
  generalTip: ["tipper", "amount", "username"],
};
function getVarTooltip(v) {
  const tooltips = {
    tipper: "Supporter's display name",
    amount: "Tip amount with currency symbol",
    goal: "Name of the tipped goal",
    goalurl: "Direct link to the goal page",
    progress: "Current funding percentage",
    remaining: "Amount still needed to reach target",
    target: "Goal's target amount",
    username: "Your SPONSA username",
  };
  return tooltips[v] || v;
}
function CharCounter({ text, limit }) {
  const len = text.length;
  const cls = len > limit ? "danger" : len > limit * 0.85 ? "warning" : "";
  return (
    <span className={`char-counter${cls ? " " + cls : ""}`}>
      {len}/{limit}
    </span>
  );
}

function SaveBar({ visible, onDiscard, onSave, saving }) {
  return (
    <div className={`save-bar${visible ? " visible" : ""}`}>
      <div className="save-bar-inner">
        <span className="save-bar-text">You have unsaved changes</span>
        <button
          className="btn btn-secondary"
          onClick={onDiscard}
          disabled={saving}
        >
          Discard
        </button>
        <button className="btn btn-primary" onClick={onSave} disabled={saving}>
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
}

function Toggle({ checked, onChange, small }) {
  return (
    <label className={`toggle-switch${small ? " small" : ""}`}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="toggle-slider" />
    </label>
  );
}

function PreviewModal({
  open,
  templateKey,
  templateText,
  hasImage,
  onClose,
  onSendTest,
}) {
  if (!open) return null;
  const validVars = X_VARS[templateKey] || [];
  const getPreviewHTML = () => {
    let text = templateText || "";
    for (const [key, val] of Object.entries(SAMPLE_DATA)) {
      if (validVars.includes(key))
        text = text.replace(new RegExp(`\\{${key}\\}`, "g"), val);
    }
    return linkifyUrls(text);
  };
  return (
    <div
      className="confirm-modal-overlay visible"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="confirm-modal"
        style={{ maxWidth: 500, textAlign: "left" }}
      >
        <div className="preview-modal-header">
          <div className="preview-modal-platform">
            <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
            <span>X (Twitter)</span>
          </div>
          <button className="preview-close-btn" onClick={onClose}>
            <svg
              width="18"
              height="18"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="preview-modal-body">
          {hasImage && (
            <div className="preview-image-section">
              <div className="preview-image-label">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
                Attached Image
              </div>
              <div className="preview-image-placeholder">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
                <span>Goal thumbnail from your goal setup</span>
              </div>
            </div>
          )}
          <div className="preview-label-row">
            <span className="preview-label">Message Preview</span>
            <span className="preview-sample-badge">Sample Data</span>
          </div>
          <div
            className="preview-message-box"
            dangerouslySetInnerHTML={{ __html: getPreviewHTML() }}
          />
        </div>
        <div className="preview-modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={onSendTest}>
            <svg
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
            </svg>
            Send Test
          </button>
        </div>
      </div>
    </div>
  );
}

function XTemplate({
  label,
  templateKey,
  value,
  onChange,
  hasImageBadge,
  enabled,
  onToggle,
  onPreview,
}) {
  const taRef = useRef(null);
  const autoResize = (el) => {
    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  };
  const insertVar = (v) => {
    const el = taRef.current;
    if (!el) return;
    const s = el.selectionStart,
      e = el.selectionEnd;
    const next = value.slice(0, s) + v + value.slice(e);
    onChange(next);
    requestAnimationFrame(() => {
      el.focus();
      el.setSelectionRange(s + v.length, s + v.length);
    });
  };
  return (
    <div className="message-template">
      <div className="template-header">
        <span className="template-label">{label}</span>
        {hasImageBadge && (
          <span className="image-attach-badge">
            <svg
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
            Goal image attached
          </span>
        )}
        <Toggle small checked={enabled} onChange={onToggle} />
      </div>
      <textarea
        ref={taRef}
        className={`template-input${templateKey === "goalComplete" ? " template-input-extra-tall" : " template-input-tall"}`}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          autoResize(e.target);
        }}
        style={{ overflow: "hidden" }}
      />
      <div className="template-footer">
        <div className="template-variables">
          {X_VARS[templateKey].map((v) => (
            <span
              key={v}
              className="variable-chip"
              data-tooltip={getVarTooltip(v)}
              onClick={() => insertVar(`{${v}}`)}
            >{`{${v}}`}</span>
          ))}
        </div>
        <CharCounter text={value} limit={280} />
      </div>
      <div className="template-actions">
        <button
          className="template-action-btn"
          onClick={() => onChange(X_DEFAULTS[templateKey])}
        >
          <svg
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M1 4v6h6" />
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
          </svg>
          Reset
        </button>
        <button className="template-action-btn" onClick={onPreview}>
          <svg
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          Preview
        </button>
      </div>
    </div>
  );
}

function templatesEqual(a, b) {
  return (
    a.goalTip === b.goalTip &&
    a.goalComplete === b.goalComplete &&
    a.generalTip === b.generalTip
  );
}
function togglesEqual(a, b) {
  return (
    a.goalTip === b.goalTip &&
    a.goalComplete === b.goalComplete &&
    a.generalTip === b.generalTip
  );
}

export default function IntegrationsSettingPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const userlogin = useSelector((state) => state.auth);

  const [connected, setConnected] = useState(false);
  const [xUsername, setXUsername] = useState("");
  const [xTemplates, setXTemplates] = useState({ ...X_DEFAULTS });
  const [xToggles, setXToggles] = useState({
    goalTip: true,
    goalComplete: true,
    generalTip: true,
  });
  const [savedState, setSavedState] = useState({
    templates: { ...X_DEFAULTS },
    toggles: { goalTip: true, goalComplete: true, generalTip: true },
  });

  const [saving, setSaving] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  // Disconnect confirmation modal — only for disconnect, NOT for discard
  const [showDisconnectX, setShowDisconnectX] = useState(false);
  const [previewState, setPreviewState] = useState({
    open: false,
    templateKey: "goalTip",
    templateText: "",
    hasImage: false,
  });

  // Computed dirty — auto-clears when changes are undone
  const dirty =
    connected &&
    (!templatesEqual(xTemplates, savedState.templates) ||
      !togglesEqual(xToggles, savedState.toggles));

  useUnsavedChanges(dirty);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("success") === "true") {
      setShowSuccessModal(true);
      params.delete("success");
      navigate(
        `${location.pathname}${params.toString() ? `?${params.toString()}` : ""}`,
        { replace: true },
      );
    }
  }, [location.search, location.pathname, navigate]);

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    const params = new URLSearchParams(location.search);
    params.delete("success");
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    if (!userlogin.uid) return;
    const fetchStatus = async () => {
      try {
        const res = await apisecured.get("/account/twitter/status");
        setConnected(res.data.connected);
        setXUsername(res.data.username || "");
        dispatch(
          setTwitterConnection({
            connected: res.data.connected,
            username: res.data.username || "",
          }),
        );
      } catch (err) {
        console.error("Error fetching Twitter status", err);
      }
    };
    fetchStatus();
  }, [userlogin.uid, dispatch]);

  useEffect(() => {
    if (!userlogin.uid) return;
    const fetchSettings = async () => {
      try {
        const res = await apisecured.get("/account/get/chatbotsettings", {
          params: { platform: "Twitter" },
        });
        const data = res.data;
        const templates = {
          goalTip: data.tipMessageTemplate || X_DEFAULTS.goalTip,
          goalComplete:
            data.fullyFundedMessageTemplate || X_DEFAULTS.goalComplete,
          generalTip: data.generalTipMessageTemplate || X_DEFAULTS.generalTip,
        };
        const toggles = {
          goalTip: data.receiveAllTips ?? true,
          goalComplete: data.receiveGoalFunded ?? true,
          generalTip: data.receiveGeneralTips ?? false,
        };
        setXTemplates(templates);
        setXToggles(toggles);
        setSavedState({ templates, toggles });
      } catch (err) {
        console.error("Failed to fetch Twitter integration settings", err);
      }
    };
    fetchSettings();
  }, [userlogin.uid]);

  // ── Switch toggle — connect redirects, disconnect shows confirmation modal ──
  const handleXSwitchToggle = async () => {
    if (connected) {
      setShowDisconnectX(true); // show confirmation, don't disconnect yet
    } else {
      try {
        const res = await apisecured.get("/account/twitter/connect-url");
        window.location.href = res.data.url;
      } catch (err) {
        console.error("Twitter connect error", err);
        dispatch(
          setToast({
            message: "Failed to initiate Twitter connection",
            type: "error",
          }),
        );
      }
    }
  };

  // ── Confirmed disconnect ──
  const handleTwitterDisconnectConfirm = async () => {
    try {
      const res = await apisecured.post("/account/twitter/disconnect");
      if (res.data.success) {
        dispatch(
          setToast({
            message: "X/Twitter disconnected successfully!",
            type: "success",
          }),
        );
        setConnected(false);
        setXUsername("");
        dispatch(setTwitterConnection({ connected: false, username: "" }));
      }
    } catch (err) {
      dispatch(
        setToast({
          message: "Failed to disconnect X/Twitter",
          type: "error",
        }),
      );
      console.error("Twitter disconnect error", err);
    } finally {
      setShowDisconnectX(false);
    }
  };

  const updateX = (key, val) => setXTemplates((p) => ({ ...p, [key]: val }));
  const toggleX = (key) => setXToggles((p) => ({ ...p, [key]: !p[key] }));

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await apisecured.post("/account/settings/chatbot", {
        platform: "Twitter",
        receiveAllTips: xToggles.goalTip,
        receiveGoalFunded: xToggles.goalComplete,
        receiveGeneralTips: xToggles.generalTip,
        tipMessageTemplate: xTemplates.goalTip,
        fullyFundedMessageTemplate: xTemplates.goalComplete,
        generalTipMessageTemplate: xTemplates.generalTip,
      });
      const d = res.data;
      setSavedState({
        templates: {
          goalTip: d.tipMessageTemplate || xTemplates.goalTip,
          goalComplete: d.fullyFundedMessageTemplate || xTemplates.goalComplete,
          generalTip: d.generalTipMessageTemplate || xTemplates.generalTip,
        },
        toggles: {
          goalTip: d.receiveAllTips ?? xToggles.goalTip,
          goalComplete: d.receiveGoalFunded ?? xToggles.goalComplete,
          generalTip: d.receiveGeneralTips ?? xToggles.generalTip,
        },
      });
      dispatch(
        setToast({
          message: "X/Twitter settings saved successfully!",
          type: "success",
        }),
      );
    } catch (error) {
      dispatch(
        setToast({
          message: `Failed to save settings: ${error?.response?.data?.error || "An unknown error occurred."}`,
          type: "error",
        }),
      );
    } finally {
      setSaving(false);
    }
  };

  // ── Discard — instant, no confirmation ──
  const handleDiscard = () => {
    setXTemplates({ ...savedState.templates });
    setXToggles({ ...savedState.toggles });
  };

  const handlePreview = (templateKey, templateText, hasImage = false) =>
    setPreviewState({ open: true, templateKey, templateText, hasImage });
  const handlePreviewClose = () =>
    setPreviewState((s) => ({ ...s, open: false }));
  const handleSendTest = async () => {
    try {
      await apisecured.post("/account/test/twitter/chatbot", {
        message: previewState.templateText,
      });
      handlePreviewClose();
      dispatch(
        setToast({
          message: "Test tweet sent to X (Twitter)!",
          type: "success",
        }),
      );
    } catch (err) {
      handlePreviewClose();
      dispatch(
        setToast({
          message: "There was an error sending a test message.",
          type: "error",
        }),
      );
    }
  };

  const xIcon = (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );

  return (
    <>
      <style>{SPONSA_CSS}</style>
      <style>{PREVIEW_CSS}</style>

      <div className="sp-settings-wrap">
        <div className="sp-settings-inner">
          <header className="page-header">
            <h1 className="page-title">Integrations</h1>
            <p className="page-description">
              Connect external services to enhance your SPONSA experience.
            </p>
          </header>

          <section className="settings-section">
            <div className="section-header">
              <div className="section-icon green">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>
              <div className="section-title-group">
                <h2 className="section-title">About Integrations</h2>
                <p className="section-subtitle">
                  Automate posts and updates across platforms
                </p>
              </div>
            </div>
            <div className="info-box">
              <p>
                Connect your social accounts to automatically share updates when
                you receive tips or complete goals. This helps keep your
                community engaged and informed!
              </p>
            </div>
          </section>

          <section className="settings-section">
            <div className="section-header">
              <div
                className="section-icon"
                style={{ background: "rgba(0,0,0,0.3)", color: "#ffffff" }}
              >
                {xIcon}
              </div>
              <div className="section-title-group">
                <h2 className="section-title">X (Twitter)</h2>
                <p className="section-subtitle">
                  {connected
                    ? `Connected as @${xUsername}`
                    : "Toggle to connect your X account"}
                </p>
              </div>
              {/* Switch — toggles connect or triggers disconnect confirmation */}
              <Toggle checked={connected} onChange={handleXSwitchToggle} />
            </div>

            {connected && (
              <div>
                <div className="connected-account-banner">
                  <div className="connected-account-info">
                    {xIcon}
                    <span>
                      Connected as <strong>@{xUsername}</strong>
                    </span>
                  </div>
                  <span
                    className="status-badge connected"
                    style={{ fontSize: 11, padding: "4px 8px" }}
                  >
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      style={{ width: 12, height: 12 }}
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    Active
                  </span>
                </div>

                <XTemplate
                  templateKey="goalTip"
                  label="Tips Towards Goals"
                  hasImageBadge
                  value={xTemplates.goalTip}
                  onChange={(v) => updateX("goalTip", v)}
                  enabled={xToggles.goalTip}
                  onToggle={() => toggleX("goalTip")}
                  onPreview={() =>
                    handlePreview("goalTip", xTemplates.goalTip, true)
                  }
                />
                <XTemplate
                  templateKey="goalComplete"
                  label="Fully Funded Goals"
                  hasImageBadge
                  value={xTemplates.goalComplete}
                  onChange={(v) => updateX("goalComplete", v)}
                  enabled={xToggles.goalComplete}
                  onToggle={() => toggleX("goalComplete")}
                  onPreview={() =>
                    handlePreview("goalComplete", xTemplates.goalComplete, true)
                  }
                />
                <XTemplate
                  templateKey="generalTip"
                  label="General Tips (No Goal)"
                  value={xTemplates.generalTip}
                  onChange={(v) => updateX("generalTip", v)}
                  enabled={xToggles.generalTip}
                  onToggle={() => toggleX("generalTip")}
                  onPreview={() =>
                    handlePreview("generalTip", xTemplates.generalTip, false)
                  }
                />
              </div>
            )}
          </section>

          <div style={{ height: 80 }} />
        </div>
      </div>

      <SaveBar
        visible={dirty}
        onDiscard={handleDiscard}
        onSave={handleSave}
        saving={saving}
      />

      {/* Disconnect confirmation — only for disconnect, NOT for discard */}
      <ConfirmModal
        open={showDisconnectX}
        onClose={() => setShowDisconnectX(false)}
        onConfirm={handleTwitterDisconnectConfirm}
        title="Disconnect X (Twitter)?"
        description="You will stop receiving automated posts to X. You can reconnect anytime."
        confirmText="Disconnect"
        cancelText="Cancel"
        isDanger={true}
      />

      <PreviewModal
        open={previewState.open}
        templateKey={previewState.templateKey}
        templateText={previewState.templateText}
        hasImage={previewState.hasImage}
        onClose={handlePreviewClose}
        onSendTest={handleSendTest}
      />

      <OnboardingCompleteModal
        open={showSuccessModal}
        onClose={handleCloseSuccessModal}
        onModalClose={handleCloseSuccessModal}
      />
    </>
  );
}
